import { FaLinkedinIn } from "react-icons/fa";
import { RiTwitterXFill } from "react-icons/ri";

export const Icons = {
  twitter: <RiTwitterXFill />,
  linkedin: <FaLinkedinIn />,
};
